import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 28.345 21.221",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28.345 21.221\" id=\"icon-arrow-right\">\n  <path id=\"icon-arrow-right_Path_18\" data-name=\"Path 18\" d=\"M12.5,45.832H37.045V49H12.5Z\" transform=\"translate(-12.5 -36.806)\" fill=\"#222\" />\n  <path id=\"icon-arrow-right_Path_19\" data-name=\"Path 19\" d=\"M55.55,43.3l-2.218-2.218,8.394-8.392L53.332,24.3l2.218-2.218,10.609,10.61Z\" transform=\"translate(-37.814 -22.082)\" fill=\"#222\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/arrow-right.svg
// module id = 101
// module chunks = 0 1 2